import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { MenuItemStyled } from "./styled";

const MenuItem = ({ theme_standard, label, icon }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <MenuItemStyled className={customClass}>
      <div className="menu_iteme_icon">{icon}</div>
      <div className="menu_item_name">{label}</div>
    </MenuItemStyled>
  );
};

MenuItem.propTypes = {};

export default MenuItem;
